<div *ngIf="carousel" class="carousel-wrapper">
  <div class="keen-navigation-wrapper">
    <div
      *ngIf="!isMobile && showArrows"
      class="arrow arrow-left"
      (click)="doPrev()"
    >
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
    <div class="keen-slider" #sliderRef>
      <div
        *ngFor="let slide of carousel; index as slideIndex"
        class="keen-slider__slide"
        [class.min-width]="isMobile"
      >
        <div
          class="carousel-slide"
          [class.active-slide]="!isMobile || slideIndex === currentSlideIndex"
        >
          <div>
            <div class="slide-top">
              <img
                *ngIf="slide.card_image?.data?.attributes?.url"
                [src]="slide.card_image?.data?.attributes?.url"
                alt="Article image"
              />
              <h2>{{ slide.title }}</h2>
            </div>
            <div class="slide-bottom">
              <p>{{ getArticleSnippet(slide.excerpt) }}</p>
            </div>
          </div>

          <a
            [href]="'app/student-life/' + slide.uid"
            class="carousel-slide-button"
            href=""
            >{{ slide.cta_text }}
            <img src="/assets/icons/thin-arrow-tertiary.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
    <div
      *ngIf="!isMobile && showArrows"
      class="arrow arrow-right"
      (click)="doNext()"
    >
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
  </div>
</div>
